import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  Chip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatSnakeCaseToTitle } from 'util/helpers';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      backgroundColor: '#121212',
      borderRadius: '0px',
      color: 'white',
      fontFamily: 'roboto !important',
    },
  },
  fieldLabel: {
    color: '#ADADAD',
    fontSize: '12px',
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5),
  },
  fieldValue: {
    color: '#F5F5F5',
    fontSize: '14px',
  },
  chip: {
    backgroundColor: '#6F9CEB',
    color: '#FFFFFF',
    fontSize: '12px',
    height: '24px',
  },
  chipDefault: {
    backgroundColor: '#525252',
    color: '#F5F5F5',
    fontSize: '12px',
    height: '24px',
  },
}));

const DriverDeviceInfoModal = ({ open, onClose, deviceInfo }) => {
  const classes = useStyles();

  if (!deviceInfo) return null;

  const renderValue = (value) => {
    if (typeof value === 'boolean') {
      return (
        <Chip
          label={value ? 'Yes' : 'No'}
          className={value ? classes.chip : classes.chipDefault}
          size="small"
        />
      );
    }
    if (typeof value === 'number') {
      return value.toString();
    }
    return value || '-';
  };

  const deviceInfoEntries = Object.entries(deviceInfo).filter(([_, value]) => value !== null && value !== undefined);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle>
        <Typography variant="h6">Driver Device Information</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {deviceInfoEntries.map(([key, value]) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Box>
                <Typography className={classes.fieldLabel} gutterBottom>
                  {formatSnakeCaseToTitle(key)}
                </Typography>
                <Typography className={classes.fieldValue}>
                  {renderValue(value)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DriverDeviceInfoModal;
